import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'awardId',
      },
    ],
  },
  target: 'ent:!awards:!award',
  quantity: 1,
  selection: {
    '{}': {
      name: 'Award Details',
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Id',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!id',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Name',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!name',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Award Number',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!code',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Federal Award Number',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!fan',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'FAIN',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!fain',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Award Period',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!award_date',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Budgeted Amount',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!budget',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Awarding Sponsor',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@': 'sponsorName',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Assistance Listing',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@': 'assistanceListingName',
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Description',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '@.': '!descr',
                  },
                  readonly: true,
                },
              },
            ],
          },
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              name: 'Edit awards overflow action',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.awards.widgets.edit-award',
                        },
                      },
                      variables: {
                        '{}': {
                          awardId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    sponsorName: {
      ref: {
        attr: 'attr:ent#!awards#!award:!sponsor',
      },
      target: 'ent:!sponsors:!sponsor',
      selection: {
        '@.': '!name',
      },
    },
    assistanceListingName: {
      ref: {
        attr: 'attr:ent#!awards#!award:!assistance_listing',
      },
      target: 'ent:!assistance_listings:!listing',
      selection: {
        '@.': '!name',
      },
    },
  },
}
